var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_394",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29262",
    "data-name": "Group 29262",
    transform: "translate(583 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -583, -11099)",
    filter: "url(#Ellipse_394)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394-2",
    "data-name": "Ellipse 394",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_9_",
    "data-name": "svgexport-17 (9)",
    transform: "translate(-564.485 -11083.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28911",
    "data-name": "Group 28911",
    transform: "translate(4.906 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49889",
    "data-name": "Path 49889",
    d: "M22.712,2H15.446a2.18,2.18,0,0,0-2.18,2.18V7.086a.727.727,0,0,0,.727.727H24.165a.727.727,0,0,0,.727-.727V4.18A2.18,2.18,0,0,0,22.712,2Zm.727,4.36H14.719V4.18a.727.727,0,0,1,.727-.727h7.266a.727.727,0,0,1,.727.727ZM9.633,29.611H6.727A.727.727,0,0,0,6,30.337v2.18A1.453,1.453,0,0,0,7.453,33.97H8.906a1.453,1.453,0,0,0,1.453-1.453v-2.18A.727.727,0,0,0,9.633,29.611Zm21.8,0H28.524a.727.727,0,0,0-.727.727v2.18a1.453,1.453,0,0,0,1.453,1.453H30.7a1.453,1.453,0,0,0,1.453-1.453v-2.18A.727.727,0,0,0,31.431,29.611Z",
    transform: "translate(-6 -2)",
    fill: "#4d5258"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8459",
    "data-name": "Rectangle 8459",
    width: 31.97,
    height: 24.704,
    rx: 5,
    transform: "translate(2 6.36)",
    fill: "#b35c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49890",
    "data-name": "Path 49890",
    d: "M23.552,14.673l-.727-2.18a.727.727,0,0,0-.923-.458l-4.36,1.453a.727.727,0,0,0-.458.923l.727,2.18a.727.727,0,0,0,.654.494.908.908,0,0,0,.233-.036l4.36-1.453a.727.727,0,0,0,.494-.923Z",
    transform: "translate(-4.114 -2.733)",
    fill: "#bee1f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 3.633,
    cy: 3.633,
    r: 3.633,
    transform: "translate(12.899 20.165)",
    fill: "#bee1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49891",
    "data-name": "Path 49891",
    d: "M41.413,30.26l-1.054-.53v-1A.727.727,0,0,0,39.633,28H36.726a.721.721,0,0,0-.7.9l.727,2.906a.727.727,0,0,0,.7.552h3.633a.727.727,0,0,0,.727-.727v-.727A.727.727,0,0,0,41.413,30.26Z",
    transform: "translate(-9.296 -7.109)",
    fill: "#a30000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8460",
    "data-name": "Rectangle 8460",
    width: 4.36,
    height: 4.36,
    rx: 1,
    transform: "translate(4.18 12.899)",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49892",
    "data-name": "Path 49892",
    d: "M38.532,16.181,34.855,14l-2.906-1.453-2.143-1.453a.727.727,0,0,0-1.1.429l-.727,2.906a.727.727,0,0,0,.269.727l2.906,2.18.109.065,4.36,2.18a.676.676,0,0,0,.363.131A.727.727,0,0,0,36.5,19.5l2.18-2.18a.734.734,0,0,0-.145-1.141Z",
    transform: "translate(-7.097 -2.454)",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49893",
    "data-name": "Path 49893",
    d: "M9.205,32l-3.633.727a.727.727,0,0,0-.581.9l.727,2.906a.727.727,0,0,0,.9.552l2.906-.727a.727.727,0,0,0,.552-.727V32.722A.754.754,0,0,0,9.205,32Z",
    transform: "translate(-0.811 -8.198)",
    fill: "#7dc3e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8461",
    "data-name": "Rectangle 8461",
    width: 7.993,
    height: 3.633,
    rx: 1,
    transform: "translate(17.259 15.805)",
    fill: "#7dc3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49894",
    "data-name": "Path 49894",
    d: "M10,8h4.36V32.7H10ZM25.985,8h4.36V32.7h-4.36Z",
    transform: "translate(-2.187 -1.64)",
    fill: "#773d00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/Suitcase.421c99e498233755ce610166c14b97d2.svg";
export { ForwardRef as ReactComponent };